import React, {useEffect, useMemo, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import {css, Global} from '@emotion/react';
import {mobile, tablet, large} from '~styles/global';
import Section from '~components/Section';
import Image from '~components/Image';
import {motion, useTransform, useViewportScroll} from 'framer-motion';
import Slide from '~components/Slide';
import useBreakpoint from '~utils/useBreakpoint';
import RowSelector from '~components/RowSelector';
import useSafari from '~utils/useSafari';
import GhostSlide from '~components/GhostSlide';

const ScrollSelector = ({data, className, bgColor}) => {
	console.log(data);
	const elRef = useRef(null);
	const rowsRef = useRef();
	const ghostSlidesRef = useRef();
	const [currentIndex, setCurrentIndex] = useState(0);
	const currentIndexRef = useRef(currentIndex);
	const slidesRef = useRef(null);
	const [scrolling, setScrolling] = useState(false);
	const {scrollY} = useViewportScroll();

	const projects = data?.projects;

	const totalOutput = [0, elRef?.current?.clientHeight];
	const imagesOutput = [0, slidesRef?.current?.clientHeight * -1];
	const rowsOutput = [0, rowsRef?.current?.clientHeight * -1];
	const [init, setInit] = useState(false);
	const translateY = useTransform(scrollY, totalOutput, rowsOutput);
	const translateSlides = useTransform(scrollY, totalOutput, imagesOutput);

	const setIndex = (value) => {
		currentIndexRef.current = value;
		setCurrentIndex(value);
	};

	const clickToScroll = (value) => {
		setIndex(value);
		const childNodes = ghostSlidesRef?.current?.children;
		const nodes = [...childNodes];
		window.scrollTo(0, nodes[currentIndexRef.current]?.offsetTop);
		// window.scrollTo(0, nodes[currentIndexRef.current]?.offsetTop)
	};

	useEffect(() => {
		if (init) {
			const childNodes = ghostSlidesRef?.current?.children;
			const nodes = [...childNodes];
			if (!scrolling) {
				setTimeout(() => {
					window.scrollTo(0, nodes[currentIndexRef.current]?.offsetTop);
				}, 100);
			}
		}
		setInit(true);
	}, [
		scrolling,
		// ghostSlidesRef?.current
	]);

	let scrollTimeout;

	const handleScroll = () => {
		setScrolling(true);
		clearTimeout(scrollTimeout);
		scrollTimeout = setTimeout(() => {
			setScrolling(false);
		}, 300);
	};

	useEffect(() => {
		document.addEventListener('scroll', handleScroll);
		return () => {
			document.removeEventListener('scroll', handleScroll);
		};
	}, []);

	const opacity = (i) => {
		if (currentIndex === i) {
			return '1';
		}
		if (currentIndex === i - 1) {
			return '0.7';
		}
		if (currentIndex === i - 2) {
			return '0.6';
		}
		if (currentIndex === i - 3) {
			return '0.5';
		}
		if (currentIndex === i - 4) {
			return '0.4';
		}
		if (currentIndex === i - 5) {
			return '0.3';
		}
		if (currentIndex === i - 6) {
			return '0.2';
		}
		if (currentIndex === i - 7) {
			return '0.1';
		}
		if (currentIndex === i - 8) {
			return '0.09';
		}
		if (currentIndex === i - 9) {
			return '0.08';
		}
		if (currentIndex === i - 10) {
			return '0.07';
		}
		if (currentIndex === i - 11) {
			return '0.06';
		}
		if (currentIndex === i - 12) {
			return '0.05';
		}
		if (currentIndex === i - 13) {
			return '0.04';
		}
		if (currentIndex === i - 14) {
			return '0.03';
		}
		if (currentIndex === i - 15) {
			return '0.02';
		} else {
			return '0';
		}
	};

	return (
		<Wrap className={className} bgColor={bgColor} key={data.title}>
			<Global
				styles={css`
					html,
					body {
						scroll-behavior: smooth;
					}
				`}
			/>
			<Rows style={{scrollY, translateY}}>
				<div ref={rowsRef}>
					{projects?.map((project, i) => (
						<Row key={project.title + i}>
							<RowSelector overIndex={currentIndex > i} to={i <= currentIndex ? project : undefined} onClick={i === currentIndex ? null : () => clickToScroll(i)} opacity={opacity} project={project} index={i} currentIndex={currentIndex} />
						</Row>
					))}
				</div>
			</Rows>
			<Slides
				// ref={elRef}
				style={{scrollY, translateY: translateSlides}}
			>
				<div ref={slidesRef}>
					<ImageBackground>
						{projects?.map((project, i) => (
							<ImageSlide
								key={project.title + i}
								i={i}
								// onChange={value => setIndex(value)}
								project={project}
							/>
						))}
					</ImageBackground>
				</div>
			</Slides>
			<div ref={elRef}>
				<GhostSlides ref={ghostSlidesRef}>
					{projects?.map((project, i) => (
						<GhostSlide key={project.title + i} i={i} onChange={(value) => setIndex(value)} project={project} />
					))}
				</GhostSlides>
			</div>
		</Wrap>
	);
};

const Wrap = styled.div`
	color: var(--white);
	box-sizing: border-box;
	position: relative;
	background-color: ${(props) => `var(--${props.bgColor})`};
`;
const Slides = styled(motion.div)`
	position: fixed;
	top: 0;
	bottom: 0;
	right: 0;
	left: 0;
	z-index: 1;
`;
const ImageBackground = styled.div``;

const ImageSlide = styled(Slide)`
	height: 100vh;
`;
const GhostSlides = styled.div`
	margin-top: 15vh;
	margin-bottom: 15vh;
`;
const Rows = styled(motion.div)`
	position: fixed;
	padding-top: 47vh;
	top: 0;
	bottom: 0;
	right: 0;
	left: 0;
	z-index: 2;
	pointer-events: none;
`;
const Row = styled(Section)``;
ScrollSelector.propTypes = {
	className: PropTypes.string,
	data: PropTypes.object,
	bgColor: PropTypes.string,
};

export default ScrollSelector;
